<template>
    <div class="zebra-crossing-detail">
        <el-form :model="form" ref='form' label-width="140px">
            
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注">
                        <el-input type='textarea' v-model="form.comment" ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1">审批通过</el-radio>
                            <el-radio :label="2">审批不通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span='24'>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit('form')">确定</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import services from './cicd.services'
    
    export default {
        props: ['deployId', 'callback'],

        data() {
            return {
                form: {
                    status: 1,
                    comment: ''
                },
            }
        },
        
        methods: {

            // 点击取消
            onCancel() {
                this.$modal.close()
            },

            // 获取atams
            getparams() {
                return {
                    ...this.form,
                    deploy_id: this.deployId
                }
            },

            // 点击确定
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        })
                        this.AddServer(loading)
                    } else {
                        loading.close();
                        return false
                    }
                })
            },

            // 添加请求
            AddServer(loading) {
                const params = this.getparams()
                services.approvalStauts(params)
                    .then(res => this.$message.success(res.message))
                    .catch( err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close();
                        this.$modal.close();
                        this.callback();
                    })
            }
        }
    }
</script>
